import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useEffect, memo } from 'react';
import useAxis from '../UseAxis';
var AxisTitle = /*#__PURE__*/memo(function (_ref) {
  var text = _ref.children,
      axisId = _ref.axisId,
      restProps = _objectWithoutProperties(_ref, ["children", "axisId"]);

  var axis = useAxis(axisId);
  useEffect(function () {
    if (axis) {
      updateAxisTitle(_objectSpread({
        text: text
      }, restProps), axis);
    }
  });
  useEffect(function () {
    return function () {
      if (axis) {
        try {
          updateAxisTitle({
            text: null
          }, axis);
        } catch (_unused) {// ignore as axis might have been already unmounted
        }
      }
    };
  }, [axis]);
  return null;
});

var updateAxisTitle = function updateAxisTitle(config, axis) {
  axis.setTitle(config, true);
};

AxisTitle.displayName = 'AxisTitle';
export default AxisTitle;